const bulletStyles = bulletColor => `
ul {
  list-style: none;
  margin-left: 15px;
}

ul li::before {
  content: '\\2022';
  color: ${bulletColor};
  font-weight: 700;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

ol {
  counter-reset: li;
  margin-left: 0;
  padding-left: 0;

  > li {
    position: relative;
    left: -5px;
    margin: 0 0 0 20px;
    padding: 2px 0;
    list-style: none;

  
  }

  > li:before {
    content: counter(li);
    counter-increment: li;
    position: absolute;
    top: -2px;
    left: -2em;
    width: 2em;
    box-sizing: border-box;

  
    padding: 4px 0;
    font-weight: 700;
    text-align: center;

    color: ${bulletColor};
  }
}

.chameleon-ol .indented-list li::before {
 margin-left: 12px;
// text-indent: 1px;

 
}

.chameleon-ul ul{
margin-left: 15px;
}

.indented-list li::before {
  content: "\\25cb" !important;
  // text-indent: -4px;
  color: ${bulletColor};
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

.indented {
padding: 0 0 0 1em;
    }
    `;

export default bulletStyles;
